import { ResponseData } from "./types";
import { httpClient } from "./common";
import { withApiErrorHandling } from "../APIs/withApiErrorHandling";

export class PaymentAttempsAPI {
  private static readonly API_URL = "/payment_attempts";

  static async getMercadoPagoLink(
    competitionId: number,
    priceId: number
  ): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.get(`${this.API_URL}/${competitionId}/${priceId}`, true),
      "Error al obtener el link de MercadoPago"
    );
  }
}
